import styled from "@emotion/styled";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CheckCircleOutlineOutlined,
  DeleteRounded,
  ErrorOutlineOutlined,
  SearchRounded,
  UploadRounded,
} from "@mui/icons-material";
import React from "react";
import TableCustom from "../../component/tableCustom";
import axios from "axios";
import Api from "../../api/RestApi.json";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function FotoPage(params) {
  const theme = useTheme();
  const goTo = useNavigate();

  const { state } = useLocation();
  const id_data = -100;
  const id_kategori = "File";
  const initialData = params.data.filter(
    (item) => item.kategori == id_kategori && item.id_foreign == id_data
  );

  const [row, setRow] = React.useState(initialData);

  const [id_foreign, setId_foreign] = React.useState(id_data);
  const [kategori, setKategori] = React.useState(id_kategori);
  const [file, setFile] = React.useState(null);

  const handleImagesUpload = (e) => {
    setFile(e.target.files[0]);
  };

  const columns = [
    {
      field: "nomor",
      headerName: "No",
      flex: 1,
      minWidth: 20,
    },
    // {
    //   field: "id",
    //   headerName: "ID",
    //   flex: 1,
    //   minWidth: 30,
    // },
    // {
    //   field: "id_foreign",
    //   headerName: "ID_Foreign",
    //   flex: 1,
    //   minWidth: 30,
    // },
    {
      field: "nama",
      headerName: "Nama File",
      flex: 3,
      minWidth: 150,
    },
    {
      field: "tipe",
      headerName: "Tipe",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "ukuran",
      headerName: "Ukuran",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "view",
      headerName: "Tampilkan",
      flex: 2,
      minWidth: 100,

      renderCell: (params) => {
        return (
          <Tooltip title="Buka Gambar">
            <IconButton
              href={Api.src + "/" + params.row.nama}
              rel="noopener noreferrer"
              target="_blank"
            >
              <SearchRounded color="primary" />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "delete",
      headerName: "Hapus",
      flex: 2,
      minWidth: 100,

      renderCell: (params) => {
        return (
          <Tooltip title="Hapus Gambar">
            <IconButton
              onClick={(e) => {
                deletePost(params.row.id);
              }}
            >
              <DeleteRounded color="error" />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const [uploadComplete, setUploadComplete] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState(0);
  const [uploadError, setUploadError] = React.useState(null);
  const [deleteStatus, setDeleteStatus] = React.useState(null);



  const deletePost = async (id) => {
    setUploadComplete(false);
    setUploadError(null);
    setDeleteStatus(null);

    try {
      var response = "";
      response = await axios.delete(Api.file + "/" + id);
      if (response !== "") {
        setDeleteStatus("Data ID-" + id + " Berhasil dihapus");
        setRow(row.filter((item) => item.id !== id));
      }
    } catch (error) {
      console.error("Error delete file:", error);
      setDeleteStatus("File gagal dihapus. Tolong Muat Ulang Halaman.");
      goTo(0)
    }
  };

  const storePost = async (event) => {
    event.preventDefault();
    setUploadProgress(0);
    setUploadComplete(false);
    setUploadError(null);
    setDeleteStatus(null);

    const formData = new FormData();
    const nameFile = Date.now() + "_" + file.name;
    formData.append("id_foreign", id_foreign);
    formData.append("kategori", kategori);
    formData.append("file", file, nameFile);
    formData.append("tipe", 'Image');
    formData.append("ukuran", file.size);
    try {
      var response = "";
      response = await axios.post(Api.file, formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);

          if (row.length > 0) {
            setRow((rowData) => [
              ...rowData,
              {
                id: rowData.length > 0 ? rowData[rowData.length - 1].id + 1 : 1,
                id_foreign: id_foreign,
                nama: nameFile,
                kategori: kategori,
                tipe: formData.get("tipe"),
                ukuran: file.size,
              },
            ]);
          }
        },
      });
      setUploadComplete(true);
      // goTo("/potensi");
      if (row.length == 0) {
        goTo(0);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadError("File gagal di Upload. Tolong ulangi kembali.");
    }
  };

  return (
    <Box padding={2} bgcolor={"white"} borderRadius={4}>
      <Grid
        container
        direction={"column"}
        spacing={2}
        padding={2}
        // justifyContent={"space-around"}
        alignItems={"start"}
      >
        <Grid>
          <Typography variant="h3" fontWeight={"bold"} align="left">
            Galeri
          </Typography>
          <form onSubmit={storePost}>
            <input type="text" name="tipe" value="Image" hidden readOnly />
            <Box
              py={2}
              component="input"
              type="file"
              name="file"
              accept="image/*"
              onChange={handleImagesUpload}
              required
            />
            {/* <br /> */}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              startIcon={<UploadRounded />}
            >
              Upload
            </Button>
          </form>
        </Grid>
      </Grid>

      {uploadProgress > 0 && (
        <Typography variant="body2" color="textSecondary">
          Upload Progress: {uploadProgress}%
        </Typography>
      )}
      {uploadComplete && (
        <Box flex={1} justifySelf={"center"}>
          <Typography
            variant="body2"
            color="success.main"
            sx={{ display: "flex", alignItems: "center" }}
          >
            Upload Complete <CheckCircleOutlineOutlined sx={{ ml: 1 }} />
          </Typography>
        </Box>
      )}
      {uploadError && (
        <Box flex={1} justifySelf={"center"}>
          <Typography
            variant="body2"
            color="error"
            sx={{ display: "flex", alignItems: "center" }}
          >
            {uploadError} <ErrorOutlineOutlined sx={{ ml: 1 }} />
          </Typography>
        </Box>
      )}

      {row.filter(
        (item) => item.kategori == id_kategori && item.id_foreign == id_data && item.tipe=='Image'
      ).length > 0 && (
        <TableCustom
          column={columns}
          row={row.filter(
        (item) => item.kategori == id_kategori && item.id_foreign == id_data && item.tipe=='Image'
      ).map((item, index) => ({
            nomor: index+1,
            id: item.id,
            id_foreign: id_data,
            nama: item.nama,
            tipe: item.tipe,
            ukuran: (item.ukuran / 1000000).toFixed(2) + " MB",
          }))}
        />
      )}

      {deleteStatus && (
        <Box flex={1} justifySelf={"center"}>
          <Typography
            variant="body2"
            color="error.main"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <DeleteRounded sx={{ ml: 1 }} /> {deleteStatus}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
